import { ResourceState } from 'ia-react-core/~/interfaces/ResourceState';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import RequestResourceFailureById from 'ia-react-core/~/actions/resource/RequestResourceFailureById';
import RequestResourceCompletedById from 'ia-react-core/~/actions/resource/RequestResourceCompletedById';
import RequestResourceCompletedByName from 'ia-react-core/~/actions/resource/RequestResourceCompletedByName';
import updateResourceById from 'ia-react-core/~/actions/resource-fn/updateResourceById';
import UpdateResourceById from 'ia-react-core/~/actions/resource/UpdateResourceById';
import get from '../../../utils/accessors/get';
import merge from '../../../utils/accessors/merge';

import requestResourceById from '../../../actions/resource-fn/requestResourceById';
import requestResourceByName from '../../../actions/resource-fn/requestResourceByName';
import requestResourceSuccessById from '../../../actions/resource-fn/requestResourceSuccessById';
import requestResourceFailureById from '../../../actions/resource-fn/requestResourceFailureById';
import resetResourceAttemptsById from '../../../actions/resource-fn/resetResourceAttemptsById';
import resetResourceAttemptsByName from '../../../actions/resource-fn/resetResourceAttemptsByName';
import requestResourceCompletedById from '../../../actions/resource-fn/requestResourceCompletedById';
import requestResourceCompletedByName from '../../../actions/resource-fn/requestResourceCompletedByName';

export default function resourceGroupReducer(state: Partial<ResourceState>, action: CoreAction) {
  const resourceId = get(state, 'resourceId');
  const resourceName = get(state, 'name');

  switch (action.type) {
    case `${requestResourceById.type}/${resourceId}`:
      return reduceRequestResource(state);
    case `${requestResourceByName.type}/${resourceName}`:
      return reduceRequestResource(state);
    case `${requestResourceSuccessById.type}/${resourceId}`:
      return reduceRequestResourceSuccess(state);
    case `${requestResourceFailureById.type}/${resourceId}`:
      return reduceRequestResourceFailure(state, action as RequestResourceFailureById);
    case `${resetResourceAttemptsById.type}/${resourceId}`:
      return reduceResetResourceAttempts(state);
    case `${resetResourceAttemptsByName.type}/${resourceName}`:
      return reduceResetResourceAttempts(state);
    case `${requestResourceCompletedById.type}/${resourceId}`:
      return reduceCompleteRequest(state, action as RequestResourceCompletedById);
    case `${requestResourceCompletedByName.type}/${resourceName}`:
      return reduceCompleteRequest(state, action as RequestResourceCompletedByName);
    case `${updateResourceById.type}/${resourceId}`:
      return reducerUpdateResource(state, action as UpdateResourceById);
    default:
      return state;
  }
}

function reduceRequestResource(state: Partial<ResourceState>): Partial<ResourceState> {
  return merge(state, {
    pending: true,
  });
}

function reduceRequestResourceSuccess(state: Partial<ResourceState>): Partial<ResourceState> {
  return merge(state, {
    error: null,
    attempts: 0,
  });
}

function reduceRequestResourceFailure(state: Partial<ResourceState>, { error: failures }: RequestResourceFailureById): Partial<ResourceState> {
  const { resourceId, error } = (
    failures as { error: Error; resourceId: number }[]
  ).find((failure) => failure);

  return merge(state, {
    error: {
      resourceId,
      message: get(error, 'message'),
      status: get(error, 'response.status') || 0,
      statusText: get(error, 'response.statusText') || get(error, 'message'),
      data: get(error, 'response.data'),
    },
    attempts: get(state, 'attempts') + 1,
  });
}

function reduceResetResourceAttempts(state: Partial<ResourceState>): Partial<ResourceState> {
  return merge(state, {
    attempts: 0,
  });
}

function reduceCompleteRequest(state: Partial<ResourceState>, { hasPendingRequests }: RequestResourceCompletedByName | RequestResourceCompletedById): Partial<ResourceState> {
  return merge(state, {
    pending: Boolean(hasPendingRequests),
    requestCount: get(state, 'requestCount') + 1,
  });
}

function reducerUpdateResource(state: Partial<ResourceState>, { state: newState }: UpdateResourceById): Partial<ResourceState> {
  return merge(state, newState);
}
